import React from "react";

const skeletonShimmer = {
  background:
    "linear-gradient(90deg, #e8ecf4 0%, #d8dce6 20%, #f0f3fa 50%, #d8dce6 80%, #e8ecf4 100%)",
  backgroundSize: "200% 100%",
  animation: "skeleton-shimmer 1.5s ease-in-out infinite",
};

const ActivityLoader = () => {
  return (
    <>
      <style>{`
        @keyframes skeleton-shimmer {
          0% { background-position: 100% 0; }
          100% { background-position: -100% 0; }
        }
      `}</style>
      <div
        className="overflow-y-auto -mx-1 px-1 space-y-0"
        style={{
          maxHeight: "350px",
          scrollbarWidth: "thin",
          scrollbarColor: "var(--light-blue) transparent",
        }}
      >
        {[1, 2, 3, 4, 5].map((i) => (
          <div
            key={i}
            className="flex items-start gap-3 py-3 border-b border-[#f0f3fa] last:border-0"
          >
            <div
              className="w-10 h-10 flex-shrink-0 rounded-full"
              style={skeletonShimmer}
            />
            <div className="min-w-0 flex-1 space-y-2">
              <div
                className="h-4 rounded"
                style={{ width: "85%", ...skeletonShimmer }}
              />
              <div
                className="h-3 rounded"
                style={{ width: "40%", ...skeletonShimmer }}
              />
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default ActivityLoader;
